import { render, staticRenderFns } from "./CreateDepartment.vue?vue&type=template&id=1b06572e&scoped=true"
import script from "./CreateDepartment.vue?vue&type=script&lang=js"
export * from "./CreateDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b06572e",
  null
  
)

export default component.exports